/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Chip_EmptyInputs */

const vi_shop_chip_empty = /** @type {(inputs: Shop_Chip_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có kết quả.`)
};

/**

* @param {Shop_Chip_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_chip_empty = /** @type {((inputs?: Shop_Chip_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Chip_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_chip_empty(inputs)
});